import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_39.module.css";
import Head from "next/head";
import BlockData from "../../../central-doctraine-json/chapter40.json";
import Common_html from "./Common_html";

export default function Chapter_40() {

    // const corosalref = useRef()

    // useEffect(() => {
    //     if (corosalref.current) {
    //         corosalref.current.scrollIntoView({
    //             behavior: "smooth",
    //             block: "nearest",
    //             inline: "start"
    //         })
    //     }
    //     console.log("CurrentImageComponent", corosalref.current);
    // }, [corosalref.current])
    return (
        <>
            <Head>
                <title>OUR GREATER UNIVERSE | School of Our Divine Infinite Being</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                ></meta>
                <meta
                    name="keywords"
                    content="Divine Infinite Being, Central Doctrine, Chapter-XL"
                ></meta>
                <meta
                    property="og:title"
                    content="OUR GREATER UNIVERSE | School of Our Divine Infinite Being"
                ></meta>
                <meta property="og:type" content="website"></meta>
                <meta
                    property="og:image"
                    content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
                ></meta>
                <meta property="og:image:alt" content="An intricate depiction of black holes intertwined with mandala patterns against a cosmic backdrop. The image represents the concept of black hole complementarity and the discovery of mandala structures within the Greater Universe, illustrating the fusion of advanced astrophysics and spiritual symbolism."></meta>
                <meta
                    property="og:description"
                    content="Explore the Central Doctrine of Black Hole Complementarity and the Discovery of the Mandala in Our Greater Universe. Delve into how black hole phenomena and mandala structures intersect, revealing profound insights into the cosmic and spiritual dimensions of our universe. Discover the unity of advanced astrophysics and divine symbolism."
                ></meta>

                <meta property="og:image:width" content="1200"></meta>
                <meta property="og:image:height" content="627"></meta>
                <meta
                    property="og:url"
                    content="https://www.divineinfinitebeing.com/central-doctrine?chapter=40"
                ></meta>

                <meta name="twitter:card" content="summary_large_image"></meta>
                <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
                <meta property="twitter:image:alt" content="An intricate depiction of black holes intertwined with mandala patterns against a cosmic backdrop. The image represents the concept of black hole complementarity and the discovery of mandala structures within the Greater Universe, illustrating the fusion of advanced astrophysics and spiritual symbolism."></meta>
                <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=40"></meta>
                <meta name="twitter:title" content="OUR GREATER UNIVERSE | School of Our Divine Infinite Being"></meta>
                <meta name="twitter:description" content="Explore the Central Doctrine of Black Hole Complementarity and the Discovery of the Mandala in Our Greater Universe. Delve into how black hole phenomena and mandala structures intersect, revealing profound insights into the cosmic and spiritual dimensions of our universe. Discover the unity of advanced astrophysics and divine symbolism."></meta>
                <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=40" />
            </Head>


            <Common_html BlockData={BlockData} />
        </>
    )
}